import React from 'react';
import { IInvoice } from '../../Interfaces/IInvoice';
import { IDocument } from '../../Interfaces/IDocument';
import { ILegalTransactionRecordNumber } from '../../Interfaces/ILegalTransactionRecordNumber';
import { Alert, Collapse } from '@mui/material';

interface IProps {
  idLegalTransactionState: number;
  invoiceArray: IDocument[];
  invoiceObjectArray: IInvoice[];
  recordNumberArray: ILegalTransactionRecordNumber[];
}

export const InvoiceWarning: React.FC<IProps> = ({
  idLegalTransactionState,
  invoiceArray,
  invoiceObjectArray,
  recordNumberArray,
}) => {
  const isEnable =
    recordNumberArray.filter(x => x.RecordNumberEntry !== '').length > 0 &&
    idLegalTransactionState === 5 &&
    invoiceObjectArray.length > 0 &&
    (recordNumberArray
      .filter(x => x.RecordNumberEntry !== '')
      .map(
        x =>
          invoiceObjectArray.find(
            y =>
              y.idLegalTransactionRecordNumber ===
              x.idLegalTransactionRecordNumber
          ) !== undefined
      )
      .some(x => x === false) ||
      invoiceObjectArray.find(
        x => x.idLegalTransactionRecordNumber === null
      ) !== undefined);

  const isDisabled =
    idLegalTransactionState != 5 ||
    invoiceArray.length >= recordNumberArray.length ||
    invoiceObjectArray.length >= recordNumberArray.length ||
    invoiceArray.length + invoiceObjectArray.length >= recordNumberArray.length;

  return (
    <Collapse in={isEnable}>
      <Alert severity='warning'>
        Für einige Urkundennummern liegt keine Rechnung vor. Bitte überprüfen
        Sie im Reiter <i>Rechnungen</i> die vorhandenen Dokumente!
      </Alert>
    </Collapse>
  );
};
